import { UserState } from '../interfaces';
import store from '../store';
import { setLoadingLogin, setLoginIsErrorMessage, setUser } from '../store/ducks/auth/actions';

export default function logoff() {
  const data: UserState = {
    id: '',
    token: '',
    login: '',
    name: '',
    userName: '',
    signed: false,
    loading: false,
    errorMessage: '',
    isError: false,
    password: '',
    permissoes: [],
  };
  localStorage.removeItem('@token');
  store.dispatch(setLoginIsErrorMessage(true));
  store.dispatch(setUser(data));
  store.dispatch(setLoadingLogin(false));
}
